module.exports = __webpack_public_path__ + "img/logos/ios-app-icon-ee5473612c58065c79b35acc7581fb0b.svg";